import { StateProvider } from '@uirouter/angularjs'
import angular from 'angular'

import errorTemplate from '../../templates/error/index.html'

import { ROUTES, STATES } from '../../../lib/routes'

/**
 * =======================================
 * ROUTES CONFIG - ERROR
 * =======================================
 *
 * @module webregister.routes.error
 */
angular
  .module('webregister.routes')
  .config(function ($stateProvider: StateProvider) {
    $stateProvider
      .state(STATES.ERROR, {
        abstract: true,
        template: errorTemplate,
      })
      .state(STATES.ERROR_OFFLINE, {
        url: ROUTES.ERROR_OFFLINE,
        component: 'offlinePage',
      })
  })
